import { render, staticRenderFns } from "./campaignModal.vue?vue&type=template&id=cbe464c4&scoped=true&"
import script from "./campaignModal.vue?vue&type=script&lang=js&"
export * from "./campaignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe464c4",
  null
  
)

export default component.exports